module.exports = __webpack_public_path__ + "assets/img/highest_priority.172018c2.svg";